import axios from 'axios';

import { auth } from '#services/http-clients.ts';

type RedeemMagicTokenResult =
  | { status: 'redeemed'; jwt: string; nextUrl: string }
  | { status: 'already-used' }
  | { status: 'failed' };

export async function redeemMagicToken(token: string): Promise<RedeemMagicTokenResult> {
  try {
    const response = await auth.post<{ jwt: string; nextUrl: string }>('/magic-tokens/redeem', {
      token,
    });
    return { status: 'redeemed', jwt: response.data.jwt, nextUrl: response.data.nextUrl };
  } catch (error) {
    if (
      axios.isAxiosError<{ error?: string }>(error) &&
      error.response?.data.error === 'already-used'
    ) {
      return { status: 'already-used' };
    }
    return { status: 'failed' };
  }
}
